import { cn } from "../../lib/utils";
import { Button, Text } from "../../primitives";

export type WorkspaceWrapperTab<TId extends string = string> = {
	id: TId;
	label: string;
};

type WorkspaceTabProps<TId extends string> = {
	tab: WorkspaceWrapperTab<TId>;
	isActive: boolean;
	panelId: string;
	testId: string;
	trackingId?: string;
	onClick: (tabId: TId) => void;
};

export function WorkspaceTab<TId extends string>({
	tab,
	isActive,
	panelId,
	testId,
	trackingId,
	onClick,
}: WorkspaceTabProps<TId>) {
	const tabButtonId = `${testId}-tab-${tab.id}`;

	return (
		<Button
			variant="ghost"
			role="tab"
			id={tabButtonId}
			aria-selected={isActive}
			aria-controls={panelId}
			onClick={() => onClick(tab.id)}
			data-testid={tabButtonId}
			trackingId={trackingId ? `${trackingId}-tab-${tab.id}` : undefined}
			className={cn(
				"h-auto pb-2 pt-5 border-b-2 -mb-px",
				isActive ? "border-brand-primary" : "group border-transparent",
			)}
		>
			<Text
				type="caption"
				color={isActive ? "primary" : "tertiary"}
				className={isActive ? undefined : "group-hover:text-secondary"}
			>
				{tab.label}
			</Text>
		</Button>
	);
}
